import { combineReducers } from 'redux';
import dialogReducer from './dialogReducers';
import widgetReducer from './widgetReducers';
import dateLogReducer from './dateLogReducer';
import clientLogReducer from './clientLogReducer';
import commentLogReducer from './commentLogReducer';
import ctyLogReducer from './countryLogReducer';
import langLogReducer from './langReducer';
import espLogReducer from './espLogReducer';
import hourLogReducer from './hourLogReducer';
import modTypeLogReducer from './modTypeLogReducer';
import moduleLogReducer from './moduleLogReducer';
import stageLogReducer from './stageLogReducer';
import taskLogReducer from './taskLogReducer';
import wplLogReducer from './wplLogReducer';
import workingHLogReducer from './workingHLogReducer';
import dataReducer from './eldDataReducer';
import postReducer from './postReducer';
import espDataReducer from './espDataReducer';
import invDataReducer from './invDataReducer';
import allPostsReducer from './allPostReducer';
import versionLogReducer from './versionReducer';

const allReducers = combineReducers({
  widget: widgetReducer,
  showDialog: dialogReducer,
  date: dateLogReducer,
  client: clientLogReducer,
  comment: commentLogReducer,
  cty: ctyLogReducer,
  lang: langLogReducer,
  esp: espLogReducer,
  hours: hourLogReducer,
  modType: modTypeLogReducer,
  module: moduleLogReducer,
  stage: stageLogReducer,
  task: taskLogReducer,
  wpl: wplLogReducer,
  wh: workingHLogReducer,
  fetch: dataReducer,
  posts: postReducer,
  esps: espDataReducer,
  invs: invDataReducer,
  allPosts: allPostsReducer,
  version: versionLogReducer,
});

export default allReducers;
